import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useEffect, useId, useRef, useState } from 'react';
import PendingListStatsPanel from './PendingListStatsPanel';

/**
 * 表头工具区：统计胶囊按钮 + 悬浮卡片（Chip + 条图）。
 */
const PendingListStatsOverlay = ({ items = [], onSelect }) => {
	const visible = (Array.isArray(items) ? items : []).filter((item) => Number(item?.amount) > 0);
	const [open, setOpen] = useState(false);
	const rootRef = useRef(null);
	const panelId = useId();

	useEffect(() => {
		if (!open) return undefined;

		const onPointerDown = (event) => {
			if (!rootRef.current?.contains(event.target)) {
				setOpen(false);
			}
		};
		const onKeyDown = (event) => {
			if (event.key === 'Escape') setOpen(false);
		};

		document.addEventListener('mousedown', onPointerDown);
		document.addEventListener('keydown', onKeyDown);
		return () => {
			document.removeEventListener('mousedown', onPointerDown);
			document.removeEventListener('keydown', onKeyDown);
		};
	}, [open]);

	if (visible.length === 0) return null;

	const handleSelect = (key) => {
		onSelect?.(key);
	};

	return (
		<div
			ref={rootRef}
			className={classNames('pending-list-stats-overlay', {
				'pending-list-stats-overlay--open': open,
			})}
		>
			<button
				type='button'
				className={classNames('pending-list-stats-overlay__btn', {
					'is-active': open,
				})}
				aria-expanded={open}
				aria-controls={panelId}
				aria-label={`统计，共${visible.length}项`}
				title='统计'
				onClick={() => setOpen((prev) => !prev)}
			>
				<FontAwesomeIcon icon='chart-bar' className='pending-list-stats-overlay__icon' />
				<span className='pending-list-stats-overlay__btn-label'>统计</span>
			</button>
			{open ? (
				<div id={panelId} className='pending-list-stats-overlay__card' role='dialog' aria-label='待办统计'>
					<div className='pending-list-stats-overlay__card-head'>
						<span className='pending-list-stats-overlay__card-title'>统计</span>
						<button
							type='button'
							className='pending-list-stats-overlay__card-close btn-reveal'
							aria-label='关闭统计'
							onClick={() => setOpen(false)}
						>
							<FontAwesomeIcon icon='xmark' />
						</button>
					</div>
					<PendingListStatsPanel items={visible} onSelect={onSelect ? handleSelect : undefined} showChart />
				</div>
			) : null}
		</div>
	);
};

PendingListStatsOverlay.propTypes = {
	items: PropTypes.arrayOf(
		PropTypes.shape({
			key: PropTypes.string.isRequired,
			label: PropTypes.string.isRequired,
			amount: PropTypes.number.isRequired,
			count: PropTypes.number,
			active: PropTypes.bool,
		}),
	),
	onSelect: PropTypes.func,
};

export default PendingListStatsOverlay;
